import apiFetch from '../apiFetch'

export default function (token, platfom) {
  return apiFetch({ endPoint: `IdocMobile/SendDownloadEmail/${platfom}`, method: 'GET', body: null, token: token })
}
